<template>
  <v-card>
    <v-card-title>
      Owner
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col
        v-for="(item, idx) in filteredItems"
        :key="idx"
        cols="12"
        md="6"
        lg="4"
        >
          <application-item-box :item="item"/>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: "ApplicationListViewBox",
  components: {
    ApplicationItemBox: () => import(
        './ApplicationItemBox'
        )
  },
  computed: {
    ...mapGetters('application', ['filteredItems'])
  },
  methods: {
    ...mapActions('application', ['findAll'])
  },
  mounted() {
    this.findAll()
  }
}
</script>

<style scoped>

</style>
